export default __webpack_public_path__ + "827e1817d7704ae5dd84be606ae74de8.svg";